import { Container, Stack } from '@mantine/core';
import PageTitle from 'components/PageTitle';
import PAGES from 'constant/pages';
import { useAppName } from 'contexts/AppProvider';
import TableCompetencyManagement from 'modules/pages/dacum/competencyManagement/TableCompetencyManagement';
import React from 'react';

const CompetencyManagementPage = () => {
  const { appName } = useAppName();
  return (
    <Container fluid>
      <Stack>
        <PageTitle
          title={PAGES[appName]?.competencyManagement?.title || ''}
          description={PAGES[appName]?.competencyManagement?.description || ''}
        />
        <TableCompetencyManagement />
      </Stack>
    </Container>
  );
};

export default CompetencyManagementPage;
